import { FC, useMemo } from "react";
import { useRoutes } from "react-router-dom";
import { SCHEMA } from "./schema";
import { buildSchema } from "./utils";

export const AppRoutes: FC = () => {
  const routes = useMemo(() => buildSchema(SCHEMA), []);
  return useRoutes(routes);
};
